import { addDessinnr } from "./add_design_number";
import { getProjectId, getProjectVersion, post_data } from "./functions";
import Modal from "../classes/modal";

async function doPublish(values) {
  const form = new FormData();
  form.append(
    "data",
    JSON.stringify({
      function: "publish",
      values,
      project_id: await getProjectId(),
      version: getProjectVersion(),
    })
  );
  const response = await post_data("./includes/ajax.inc.php", form);
  if(response.status !== "error"){
    addDessinnr(response.array);
  }
  return response;
}

export async function publishFormData(values) {
  const response = await doPublish(values);

  if (response.status === "error" && response.execution === "ask_new_pair") {
    const modal = new Modal();
    const confirmed = await modal.showConfirm(
      response.message,
      "Get new numbers",
      "Cancel"
    );
    if (!confirmed) return { status: "error", message: "Publishing cancelled." };
    return doPublish({ ...values, forceNewPair: true });
  }

  return response;
}
